import { StyleSheet } from 'aphrodite';
import { charmGray, error, successGreen, warningDark } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	row: {
		borderBottom: `1px solid ${charmGray}`,
		':hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.1)',
		},
	},
	cell: {
		padding: '12px 16px',
		verticalAlign: 'middle',
	},
	contactInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
	},
	contactName: {
		fontWeight: 500,
		fontSize: '14px',
	},
	companyName: {
		fontSize: '12px',
	},
	callTime: {
		fontSize: '14px',
	},
	duration: {
		fontSize: '14px',
		fontFamily: 'monospace',
	},
	transcriptionStatus: {
		fontSize: '12px',
		fontWeight: 500,
		padding: '4px 8px',
		borderRadius: '12px',
		textAlign: 'center',
		minWidth: '80px',
	},
	statusAvailable: {
		backgroundColor: '#e8f5e8',
		color: successGreen,
	},
	statusProcessing: {
		backgroundColor: '#fff4e6',
		color: warningDark,
	},
	statusFailed: {
		backgroundColor: '#ffeaea',
		color: error,
	},
	statusUnavailable: {
		backgroundColor: '#f5f5f5',
		color: charmGray,
	},
	callTypeBadge: {
		fontSize: '10px',
		fontWeight: 600,
		padding: '2px 6px',
		borderRadius: '4px',
		textTransform: 'uppercase',
		letterSpacing: '0.5px',
		marginLeft: '8px',
		display: 'inline-block',
	},
	practiceCallBadge: {
		backgroundColor: '#e6f3ff',
		color: '#0066cc',
		border: '1px solid #0066cc40',
	},
});
